import axios from "axios";
import Cookies from 'js-cookie';
import { APIURL, getHeaders } from "./config";

let isRedirectingToLogin = false;

export const INVALID_DEVICE_EVENT = 'itask:invalid-device';

export const emitInvalidDevice = (message) => {
  try {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(
      new CustomEvent(INVALID_DEVICE_EVENT, {
        detail: { message: message || 'Invalid device. Please login again.' },
      })
    );
  } catch (e) {
    console.error('Failed to emit invalid device event:', e);
  }
};

export const redirectToLogin = () => {
  if (isRedirectingToLogin) return;
  isRedirectingToLogin = true;
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (e) {
    console.error("Error clearing storage during logout redirect:", e);
  }
  const logoutUrl = process.env.React_APP_LOGOUT_URL;
  if (logoutUrl) {
    window.location.href = logoutUrl;
  } else {
    window.location.href = "/";
  }
};

export const apiClient = axios.create();

apiClient.interceptors.response.use(
  (response) => {
    const shouldSkipTokenUpdate = response?.config?.skipTokenUpdate;
    if (!shouldSkipTokenUpdate) {
      const requestToken = response?.data?.Data?.RequestToken;
      if (requestToken) {
        const tokenWithBearer = requestToken.startsWith('Bearer ')
          ? requestToken
          : `Bearer ${requestToken}`;
        const cookieDomain = (typeof window !== 'undefined' && window?.location?.hostname?.endsWith('optigoapps.com'))
          ? '.optigoapps.com'
          : undefined;

        const cookieOptions = cookieDomain ? { domain: cookieDomain } : {};
        const expiresAt = new Date(Date.now() + 15 * 60 * 1000);
        Cookies.set('auth', tokenWithBearer, { ...cookieOptions, expires: expiresAt });
      }
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export const CommonAPI = async (body, options = {}) => {
  try {
    const init = JSON.parse(sessionStorage.getItem("taskInit")) || {};
    const headers = await getHeaders(init, options);

    console.log("header", headers)
    const { data } = await apiClient.post(APIURL, body, {
      headers,
      skipTokenUpdate: options?.skipTokenUpdate,
    });


    const row0 = data?.Data?.rd?.[0];
    if (row0?.stat_code === 1001 || row0?.stat_msg === 'Invalid Device!!') {
      emitInvalidDevice(row0?.stat_msg || 'Invalid Device!!');
      return null;
    }
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};

